// extracted by mini-css-extract-plugin
export var h1 = "Heading-module--h1--2b1ke";
export var h2 = "Heading-module--h2--tMgvp";
export var h3 = "Heading-module--h3--jtTXY";
export var h4 = "Heading-module--h4--1342R";
export var h5 = "Heading-module--h5--dvELV";
export var h6 = "Heading-module--h6--21mGm";
export var noMargin = "Heading-module--noMargin--1D2BZ";